import { render, staticRenderFns } from "./newBusiness.vue?vue&type=template&id=9ac980ea&scoped=true"
import script from "./newBusiness.vue?vue&type=script&lang=js"
export * from "./newBusiness.vue?vue&type=script&lang=js"
import style0 from "./newBusiness.vue?vue&type=style&index=0&id=9ac980ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac980ea",
  null
  
)

export default component.exports